import { render, staticRenderFns } from "./resources-tree.vue?vue&type=template&id=7b808f9e"
import script from "./resources-tree.vue?vue&type=script&lang=ts"
export * from "./resources-tree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports